export const SET_GEO_LOCATION_VALUE = 'src/store/geolocation/SET_GEO_LOCATION_VALUE';
